import { tools } from '../../object-plus/index.js';
import { setAttribute } from '../updates.js';
const { notEqual, assign } = tools;
const emptyOptions = {};
export class AnyType {
    canBeUpdated(prev, next, options) { }
    transform(next, prev, model, options) { return next; }
    convert(next, prev, model, options) { return next; }
    isChanged(a, b) {
        return notEqual(a, b);
    }
    handleChange(next, prev, model, options) { }
    create() { return void 0; }
    clone(value, record) {
        return value;
    }
    dispose(record, value) {
        this.handleChange(void 0, value, record, emptyOptions);
    }
    validate(record, value, key) { }
    toJSON(value, key, options) {
        return value && value.toJSON ? value.toJSON(options) : value;
    }
    createPropertyDescriptor() {
        const { name, getHook } = this;
        if (name !== 'id') {
            return {
                set(value) {
                    setAttribute(this, name, value);
                },
                get: (getHook ?
                    function () {
                        return getHook.call(this, this.attributes[name], name);
                    } :
                    function () { return this.attributes[name]; }),
                configurable: true
            };
        }
    }
    initialize(name, options) { }
    doInit(value, record, options) {
        const v = value === void 0 ? this.defaultValue() : value, x = this.transform(v, void 0, record, options);
        this.handleChange(x, void 0, record, options);
        return x;
    }
    doUpdate(value, record, options, nested) {
        const { name } = this, { attributes } = record, prev = attributes[name];
        const next = this.transform(value, prev, record, options);
        attributes[name] = next;
        if (this.isChanged(next, prev)) {
            this.handleChange(next, prev, record, options);
            return true;
        }
        return false;
    }
    _log(level, code, text, value, record, logger) {
        record._log(level, code, `${record.getClassName()}.${this.name} ${text}`, {
            'New value': value,
            'Prev. value': record.attributes[this.name]
        }, logger);
    }
    defaultValue() {
        return this.value;
    }
    constructor(name, a_options) {
        this.name = name;
        this.getHook = null;
        this.options = a_options;
        const options = Object.assign({ getHooks: [], transforms: [], changeHandlers: [] }, a_options);
        options.getHooks = options.getHooks.slice();
        options.transforms = options.transforms.slice();
        options.changeHandlers = options.changeHandlers.slice();
        const { value, type, parse, toJSON, changeEvents, validate, getHooks, transforms, changeHandlers } = options;
        this.value = value;
        this.type = type;
        if (!options.hasCustomDefault && type) {
            this.defaultValue = this.create;
        }
        else if (tools.isValidJSON(value)) {
            this.defaultValue = new Function(`return ${JSON.stringify(value)};`);
        }
        else {
            this.defaultValue = this.defaultValue;
        }
        this.propagateChanges = changeEvents !== false;
        this.toJSON = toJSON === void 0 ? this.toJSON : toJSON;
        this.validate = validate || this.validate;
        if (options.isRequired) {
            this.validate = wrapIsRequired(this.validate);
        }
        transforms.unshift(this.convert);
        if (this.get)
            getHooks.unshift(this.get);
        this.initialize.call(this, options);
        if (getHooks.length) {
            const getHook = this.getHook = getHooks.reduce(chainGetHooks);
            const { validate } = this;
            this.validate = function (record, value, key) {
                return validate.call(this, record, getHook.call(record, value, key), key);
            };
        }
        this.transform = transforms.length ? transforms.reduce(chainTransforms) : this.transform;
        this.handleChange = changeHandlers.length ? changeHandlers.reduce(chainChangeHandlers) : this.handleChange;
        const { doInit, doUpdate } = this;
        this.doInit = parse ? function (value, record, options) {
            return doInit.call(this, options.parse && value !== void 0 ? parse.call(record, value, this.name) : value, record, options);
        } : doInit;
        this.doUpdate = parse ? function (value, record, options, nested) {
            return doUpdate.call(this, options.parse && value !== void 0 ? parse.call(record, value, this.name) : value, record, options, nested);
        } : doUpdate;
    }
}
function chainGetHooks(prevHook, nextHook) {
    return function (value, name) {
        return nextHook.call(this, prevHook.call(this, value, name), name);
    };
}
function chainTransforms(prevTransform, nextTransform) {
    return function (next, prev, record, options) {
        return nextTransform.call(this, prevTransform.call(this, next, prev, record, options), prev, record, options);
    };
}
function chainChangeHandlers(prevHandler, nextHandler) {
    return function (next, prev, record, options) {
        prevHandler.call(this, next, prev, record, options);
        nextHandler.call(this, next, prev, record, options);
    };
}
function wrapIsRequired(validate) {
    return function (record, value, key) {
        return value ? validate.call(this, record, value, key) : 'Required';
    };
}
//# sourceMappingURL=any.js.map